document.addEventListener('DOMContentLoaded', function () {


// ********* START: Sliding Icons *********** /
// Check if Swiper is loaded
if (typeof Swiper === 'undefined') return;

// Get all sections with sliding-icons class
const allSections = document.querySelectorAll('.sliding-icons');
if (!allSections || allSections.length === 0) return;

allSections.forEach(section => {
    const wrapper = section.querySelector('.swiper-wrapper');
    const slide = wrapper ? wrapper.querySelector('.slide-template') : null;

    // Only proceed if wrapper and template slide exist
    if (!wrapper || !slide) return;

    const MAX_DUPLICATES = 20;

    // Clone slides
    for (let i = 0; i < MAX_DUPLICATES; i++) {
        const clone = slide.cloneNode(true);
        wrapper.appendChild(clone);
    }

    // Initialize Swiper for THIS section
    new Swiper(section, {
        slidesPerView: 'auto',
        loop: true,
        speed: 10000,
        allowTouchMove: false,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        spaceBetween: 20,
    });
});
// ********* END: Sliding Icons *********** /


});